import styled from 'styled-components';
export const LiveArenaWidgetCapsuleMidContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    background: url(${props => props.theme.images.liveArena.liveArenaWidget.infoCapsule.backgroundMiddle.toString()});
    background-size: 100% 100%;
    background-repeat: repeat-x;
    height: 100%;
`;
